import { useRoutes } from "react-router-dom";
import { publicRoutes } from "./Public";
import { protectedRoutes } from "./Protected";

const AppRouter = () => {
  const routes = useRoutes([...publicRoutes, ...protectedRoutes]);
  return routes;
};

export default AppRouter;
